jQuery(document).ready(function($){
  "use strict";

  var $window = $(window);
  var $body = $('body');
  var $main = $('#main');
  var $header = $('.header--primary');
  var headerHeight = $header.outerHeight();
  var scrollpos = 0;
  var lastScrollTop = 0;

  $window.scroll(onScroll);

  function onScroll() {
    var scroll = $window.scrollTop();
    var st = window.pageYOffset || document.documentElement.scrollTop;
    scrollpos = scroll;
    if (scroll >= headerHeight) {
      if(st > lastScrollTop) {
        $body.addClass('scrolled');
        $body.removeClass('scrolled-up');
      } else {
        $body.addClass('scrolled-up');
      }
    } else {
      $body.removeClass('scrolled');
    }

    lastScrollTop = st;
  }

  onScroll();

  var hh = $header.outerHeight();

  $main.css('padding-top', hh + 'px')
  $window.resize(function(){
    hh = $header.outerHeight();
    $main.css('padding-top', hh + 'px')
  });
});
